import { styled, Stack, Divider } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ReplacementOptimizationHeader from './ReplacementOptimizationHeader';
import ReplacementOptimizationBody from './ReplacementOptimizationBody';
import ReplacementOptimizationActions from './ReplacementOptimizationActions';
import LogOnEnter from '../../../CustomComponents/LogOnEnter';
import { useGetItemReplacementByRecommendationIdQuery, useLogUserActionMutation } from '../../../../api/physicianDashboardSlice';
import ItemReplacementDetails from '../../ItemReplacements/ItemReplacementDetails';

function ReplacementOptimization({ recommendation, draft }) {
    const theme = useTheme();
    const [isReviewOpen, setIsReviewOpen] = useState(false);
    const [logUserAction] = useLogUserActionMutation();

    const { data: replacement } = useGetItemReplacementByRecommendationIdQuery(recommendation.id, { skip: !isReviewOpen });

    const logRecommendationAction = async (action) => {
        await logUserAction({
            action: action,
            data: {
                location: 'ReplacementOptimization',
                recommendation: recommendation
            }
        });
    };

    const handleReviewReplacement = () => {
        setIsReviewOpen(true);
        logRecommendationAction('viewed_replacement_details');
    };

    const variants = {
        open: {
            backgroundColor: `${theme.palette.background.white}`,
            transition: { duration: 0.3 }
        },
        accepted: { transition: { duration: 0.3 } },
        rejected: { transition: { duration: 0.3 } }
    };

    return (
        <LogOnEnter action='viewed_recommendation' data={{ recommendation }}>
            <OptimizationBox
                component={motion.div} initial={false} animate={recommendation.status} variants={variants} transition={{ duration: 1.2, type: 'spring', bounce: 0.1 }}
            >
                <Stack>
                    <Stack px={2} pt={1.5} pb={0.5} spacing={1}>
                        <ReplacementOptimizationHeader recommendation={recommendation} />
                        <ReplacementOptimizationBody recommendation={recommendation} />
                    </Stack>
                    <Divider />
                    <ReplacementOptimizationActions
                        locked={recommendation.clinical_review && recommendation.clinical_review?.submitted_at !== null}
                        status={recommendation.status}
                        handleReviewReplacement={handleReviewReplacement}
                    />
                </Stack>
            </OptimizationBox>
            { isReviewOpen &&
                <ItemReplacementDetails
                    replacement={replacement}
                    cardOwnerId={draft.card.doctor.id}
                    draft={draft}
                    onBack={() => setIsReviewOpen(false)}
                    navigationAction={{
                        label: 'Back to Card',
                        onClick: () => setIsReviewOpen(false)
                    }}
                />
            }
        </LogOnEnter>
    );
}

const OptimizationBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.white,
    borderRadius: '4px',
}));

export default ReplacementOptimization;
